import { render } from "./legoPaginationExtendV2.vue?vue&type=template&id=1f995628&scoped=true"
import script from "./legoPaginationExtendV2.vue?vue&type=script&lang=js"
export * from "./legoPaginationExtendV2.vue?vue&type=script&lang=js"

import "./legoPaginationExtendV2.vue?vue&type=style&index=0&id=1f995628&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f995628"],['__file',"src/components/lego/extend/legoPaginationExtendV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f995628"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f995628', __exports__)) {
    api.reload('1f995628', __exports__)
  }
  
  module.hot.accept("./legoPaginationExtendV2.vue?vue&type=template&id=1f995628&scoped=true", () => {
    api.rerender('1f995628', render)
  })

}


export default __exports__